module.exports = __webpack_public_path__ + "static/media/support_image.1baae50f.png";